import {
  STAR_MSG_ERROR,
  RESET_STAR_OBJ,
  RESET_STAR_STATUS,
  STAR_MSG,
  STARRED_MSG,
} from "./actionTypes";

const initialState = {
  status: {},
  data: {},
};

const FavoriteMessages = (state = initialState, action) => {
  switch (action.type) {
    case STAR_MSG_ERROR:
      state = {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            error: {
              status: true,
              message: action?.payload?.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case RESET_STAR_OBJ:
      state = initialState;
      break;
    case RESET_STAR_STATUS:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload]: null,
        },
      };
      break;
    case STAR_MSG:
      state = {
        ...state,
        data: action.payload,
        status: {
          ...state?.status,
          star_message: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case STARRED_MSG:
      state = {
        ...state,
        status: {
          star_message: {
            error: false,
            loading: false,
            success: {
              status: true,
              chatId: action?.payload?.chatId,
              msgId: action?.payload?.msgId,
              starred: action?.payload?.starred,
            },
          },
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default FavoriteMessages;
